/**
 * global process
 */

import { memo, ReactNode, FunctionComponent } from 'react';

import { AppConfigContext } from '../Context';
import { useAppConfigQuery } from '@/graphql/generated';

interface Props {
  children: ReactNode;
}

const AppConfigProvider: FunctionComponent<Props> = memo(({ children }) => {
  const { data: result } = useAppConfigQuery({
    variables: { id: process.env.LousivMBA || '' }
  });

  if (!result) {
    return null;
  }

  return (
    <AppConfigContext.Provider
      value={{
        appConfig: {
          toolkitId: process.env.LousivMBA || '',
          ...result.appConfig
        }
      }}
    >
      {children}
    </AppConfigContext.Provider>
  );
});

export default AppConfigProvider;
